import { Map } from 'immutable';
import { FETCH_INSTAGRAM_POSTS_SUCCESS, FETCH_INSTAGRAM_POSTS_FAIL } from '../actions/actionTypes';

const initialState = Map();

const formatData = (arrayData, key = 'id') =>
  arrayData.reduce((memory, item) => memory.merge({ [item.get(key)]: item }), Map());

export function instagram(state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_INSTAGRAM_POSTS_SUCCESS:
      return formatData(payload);

    case FETCH_INSTAGRAM_POSTS_FAIL:
      return state;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/instagram.js